import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import { browserHistory } from 'react-router';
import Button from '../../../core/form/Button';
import AudioPreview from '../../../core/layout/AudioPreview';
import Icon from '../../../core/layout/Icon';

const InstructionAudioExpandableTable = (props) => (
  <Table
    columns={[
      {
        label: 'Locale',
        path: 'locale',
        width: '60px',
      },
      {
        label: 'Text',
        path: 'text',
      },
      {
        label: 'Actions',
        path: 'action',
        width: '60px',
        render: (cell, row) => (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {row.audio ? (
              <AudioPreview src={row.audio} />
            ) : (
              <Icon name="exclamation-circle" style={{ fontSize: '20px' }} />
            )}
          </div>
        ),
      },
    ]}
    rows={props.data}
  />
);

const InstructionAudioList = (props) => (
  <Table
    fetching={props.items.loading}
    expandableComponent={(row) => <InstructionAudioExpandableTable data={row.instructions} />}
    columns={[
      {
        label: 'Type',
        path: 'type',
        sort: true,
      },
      {
        label: 'Key',
        path: 'key',
        sort: true,
      },
      {
        label: 'Actions',
        path: 'action',
        width: '90px',
        render: (cell, row) => {
          return (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button icon="edit" onClick={() => browserHistory.push(`/instruction-audios/${row.id}`)} />
              <Button icon="delete" onClick={() => props.onDelete(row)} />
            </div>
          );
        },
      },
    ]}
    rows={props.items}
    pagination={props.pagination}
    onDelete={props.onDelete}
  />
);

InstructionAudioList.propTypes = {
  onDelete: PropTypes.func,
  items: PropTypes.array,
  loading: PropTypes.bool,
  pagination: PropTypes.shape({
    current: PropTypes.number,
    pageSize: PropTypes.number,
    total: PropTypes.number,
  }),
};

InstructionAudioList.defaultProps = {
  items: [],
  loading: false,
};

export default InstructionAudioList;
